import React from "react";

// icons
import ModeEditOutlineOutlinedIcon from "@mui/icons-material/ModeEditOutlineOutlined";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from '@mui/icons-material/Add';

const CompteDetail = () => {
  return (
    <div className="w-full h-full mx-auto pt-3">
      <div>
        <div className="w-11/12 mx-auto px-10 pt-10">
          <h1 className="text-3xl font-bold text-black">Account details</h1>
          <p className="font-medium text-lg">Personal details</p>
        </div>

        <div className="mt-10 pb-12 w-11/12 mx-auto px-10">
          <div className="flex items-center gap-x-32 py-2">
            <div>
              <p className="uppercase text-sm text-gray-400 font-normal">
                Your name
              </p>
              <p className="text-base text-black font-medium">Chris Rasdre</p>
            </div>
            <div>
              <button className="flex items-center border-2 border-black px-2 gap-x-1 rounded-full">
                <ModeEditOutlineOutlinedIcon sx={{ fontSize: 18 }} />
                <span className="text-sm font-bold">Edit</span>
              </button>
            </div>
          </div>
          <div className="flex items-center gap-x-32 py-2">
            <div>
              <p className="uppercase text-sm text-gray-400 font-normal">
                Email address
              </p>
              <p className="text-base text-black font-medium">
                bomboclaa@gmail.com
              </p>
            </div>
          </div>
          <div className="flex items-center gap-x-36 py-2">
            <div>
              <p className="uppercase text-sm text-gray-400 font-normal">
                Password
              </p>
              <p className="text-base text-black font-medium">*****</p>
            </div>
            <div>
              <button className="flex items-center border-2 border-black px-3 py-px gap-x-1 rounded-full">
                <span className="text-sm font-bold">Reset</span>
              </button>
            </div>
          </div>
          <div className="flex items-center gap-x-32 py-2">
            <div>
              <p className="uppercase text-sm text-gray-400 font-normal">
                Mobile number
              </p>
              <p className="text-base text-black font-medium">Chris Rasdre</p>
            </div>
          </div>
          <div className="flex items-center gap-x-32 py-2">
            <div>
              <p className="uppercase text-sm text-gray-400 font-normal">
                Password
              </p>
              <p className="text-base text-black font-medium">Chris Rasdre</p>
            </div>
            <div>
              <button className="flex items-center border-2 border-black px-2 gap-x-1 rounded-full">
                <ModeEditOutlineOutlinedIcon sx={{ fontSize: 18 }} />
                <span className="text-sm font-bold">Edit</span>
              </button>
            </div>
          </div>
        </div>

        <div className="bg-gray-mtn h-fit px-10 pt-10">
          <div className="w-11/12 mx-auto pb-20">
            <h3 className="font-medium text-xl text-black">Address details</h3>
            <div className="mt-10">
              <div className="w-80 h-fit bg-white rounded-xl p-2">
                <div className="bg-gray-mtn w-full h-fit rounded-xl px-4 py-2">
                  <div>
                    <p className="text-sm font-medium">
                      Palmeraie, Abidjan Côte d'ivoire
                    </p>
                    <p className="text-sm font-medium">Palmeraie 421 NZE</p>
                    <p className="text-sm font-medium">Côte d'ivoire</p>
                  </div>
                  <div className="mt-3">
                    <p className="text-sm font-medium">0756 332 1246</p>
                    <p className="text-sm font-medium">ID. *******11</p>
                  </div>
                </div>
                <div className="flex items-center gap-x-5 px-4 pt-1 pb-px">
                  <button>
                    <ModeEditIcon sx={{ fontSize: 15 }} />
                    <span className="text-gray-500 underline text-xs">
                      Edit / Update
                    </span>
                  </button>
                  <button>
                    <DeleteIcon sx={{ fontSize: 15 }} />
                    <span className="text-gray-500 underline text-xs">
                      Delete
                    </span>
                  </button>
                </div>
              </div>
              <div className="mt-3">
                <button className="relative bg-jaune-mtn w-80 h-10 rounded-full text-center">
                  <div className="absolute top-1 left-1 w-8 h-8 rounded-full bg-white flex items-center justify-center">
                    <AddIcon />
                  </div>
                  <span className="font-bold">Add address</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompteDetail;
